module.exports = __webpack_public_path__ + "static/media/fluteplay.99a0c8cf.JPG";